import { render, staticRenderFns } from "./MultipaneResizer.vue?vue&type=template&id=79caa962&"
import script from "./MultipaneResizer.vue?vue&type=script&lang=js&"
export * from "./MultipaneResizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports